import React from 'react'
import { Link } from 'react-router-dom'
import './SiteFooter.css'

const LINKS = [
  { to: '/hans', label: 'Territorios' },
  { to: '/aventuras', label: 'Aventuras' },
  { to: '/mapa', label: 'Mapa' },
  { to: '/clanes', label: 'Clanes' },
]

export default function SiteFooter() {
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <Link to="/" className="site-footer__title">
          Shinobis&apos; War
        </Link>
        <p className="site-footer__tagline">Foro de rol · Tierras del shinobi</p>

        <nav className="site-footer__nav" aria-label="Enlaces del pie">
          {LINKS.map((item, index) => (
            <React.Fragment key={item.to}>
              {index > 0 && (
                <span className="site-footer__sep" aria-hidden="true">
                  ·
                </span>
              )}
              <Link to={item.to} className="site-footer__link">
                {item.label}
              </Link>
            </React.Fragment>
          ))}
        </nav>

        <p className="site-footer__meta">© {year} · Era beta</p>
      </div>
    </footer>
  )
}
